import { render, staticRenderFns } from "./HomeIndent.vue?vue&type=template&id=12fa1421&scoped=true"
import script from "./HomeIndent.vue?vue&type=script&lang=js"
export * from "./HomeIndent.vue?vue&type=script&lang=js"
import style0 from "./HomeIndent.vue?vue&type=style&index=0&id=12fa1421&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fa1421",
  null
  
)

export default component.exports